'use client'
import { useTranslation } from 'react-i18next'
import SubHeading from './SubHeading'
import Accordion, { type Props as AccordionProps } from '@/components/Accordion'
import { useMemo } from 'react'
import Image from 'next/image'

interface Props {
    symbols?: string | null
    sentences?: string | null
    storage?: string | null
}
export default function ProductSafetyInfo({
    symbols = '',
    sentences = '',
    storage = '',
}: Props) {
    const { t } = useTranslation()

    const accordionItems = useMemo((): AccordionProps['items'] => {
        return [
            {
                label: t('eshop.productdetail.safety.sentences'),
                body: <span>{sentences}</span>,
            },
            {
                label: t('eshop.productdetail.safety.storage'),
                body: <span>{storage}</span>,
            },
        ]
    }, [sentences, storage, t])

    const validSymbols = useMemo(
        () => symbols?.split(' ')?.filter((x) => !!x) || [],
        [symbols]
    )

    return (
        <>
            <SubHeading>{t('eshop.productdetail.safety.heading')}:</SubHeading>
            <div className="flex gap-4 text-sm">
                {validSymbols.map((s) => (
                    <div key={s}>
                        <Image
                            src={`/safety/${s}.jpeg`}
                            alt={s}
                            width={44}
                            height={44}
                            className="mb-2"
                        />

                        {s}
                    </div>
                ))}
                {validSymbols.length === 0 && <span>---</span>}
            </div>
            <Accordion
                items={accordionItems}
                singleOpen={false}
                id="sentences"
            />
        </>
    )
}
